export interface IIntegration {
    callback_url: string
    id: string
}

export interface IUpdateIntegration {
    callback_url: string
}

export interface ICreateIntegration {
    callback_url: string
}

// Контракт провайдера `CommunityServiceExternalApi@1.0.0`
// (`oem-backend-community-nest`, Wave W3): три независимых read scope,
// по умолчанию не выданы. Значения — единственные допустимые, сервер
// отклоняет любое другое (`scopes contains an unsupported partner scope`).
export const PARTNER_SCOPES = [
    'admin-audit:read',
    'iam-admins:read',
    'partner-events:read',
] as const

export type PartnerScope = (typeof PARTNER_SCOPES)[number]

/**
 * Провайдер может со временем добавить новый scope. Такой идентификатор
 * клиенту неизвестен: показать переключатель для него нельзя, но и молча
 * потерять при сохранении тоже нельзя — это сузило бы права ключа.
 * Поэтому набор разрешений типизирован шире трёх известных значений.
 */
export type ApiKeyScope = PartnerScope | (string & {})

export interface IApiKey {
    token: string
    id: string
    enabled: boolean
    bot_id: string
    scopes: ApiKeyScope[]
}

export interface IUpdateApiKey {
    enabled?: boolean
    scopes?: ApiKeyScope[]
}
